import { AEMWelcomeTour } from '../../models/aem/aem-welcomeTour.interfaces';

export const AEMWelcomeTourMocks: AEMWelcomeTour = {
  header: 'The New Delta SkyMiles',
  slides: [
    {
      desktopImage: {
        alt: 'desktop view',
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/welcome-tour/slide-1.png'
      },
      mobileImage: {
        alt: 'mobile view',
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/welcome-tour/slide-1-mobile.png'
      },
      content: {
        title: 'SKYMILES IS TAKING OFF',
        subtitle:
          'Your SkyMiles Overview page is your custom dashboard here to help you make the most of your membership. Explore your Benefits, Account Activity, Promotions, Partners and more.'
      }
    },
    {
      desktopImage: {
        alt: 'desktop view',
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/welcome-tour/slide-2.png'
      },
      mobileImage: {
        alt: 'mobile view',
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/welcome-tour/slide-2-mobile.png'
      },
      content: {
        title: 'A NEW SKYMILES STATUS TRACKING LOOK',
        subtitle:
          'At the very top of your SkyMiles Overview page you’re able to track your status and navigate to many relevant pages. '
      }
    },
    {
      desktopImage: {
        alt: 'desktop view',
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/welcome-tour/slide-3.png'
      },
      mobileImage: {
        alt: 'mobile view',
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/welcome-tour/slide-3-mobile.png'
      },
      content: {
        title: 'CURRENT STATUS + FUTURE STATUS PROGRESS',
        subtitle: 'Track your current SkyMiles balance and book with miles.'
      }
    },
    {
      desktopImage: {
        alt: 'desktop view',
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/welcome-tour/slide-4.png'
      },
      mobileImage: {
        alt: 'mobile view',
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/welcome-tour/slide-4-mobile.png'
      },
      content: {
        title: 'MEDALLION STATUS TRACKERS',
        subtitle:
          'The Medallion Status trackers are made up of two categories — Flight and Spend. Reach status by completeing a qualifier in each category.'
      }
    },
    {
      desktopImage: {
        alt: 'desktop view',
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/welcome-tour/slide-5.png'
      },
      mobileImage: {
        alt: 'mobile view',
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/welcome-tour/slide-5-mobile.png'
      },
      content: {
        title: 'FLIGHT QUALIFIER CATEGORY',
        subtitle:
          'Medallion Qualification Miles and Medallion Qualification Segments make up the Flight Qualifier Category. Only one of these qualifers needs to be completed to complete the category.'
      }
    },
    {
      desktopImage: {
        alt: 'desktop view',
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/welcome-tour/slide-6.png'
      },
      mobileImage: {
        alt: 'mobile view',
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/welcome-tour/slide-6-mobile.png'
      },
      content: {
        title: 'SPEND QUALIFIER CATEGORY',
        subtitle:
          'Medallion Qualification Dollars and Delta SkyMiles Amex Card Spending make up the Spend Qualifier Category. Only one of these qualifers needs to be completed to complete the category.'
      }
    },
    {
      desktopImage: {
        alt: 'desktop view',
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/welcome-tour/slide-7.png'
      },
      mobileImage: {
        alt: 'mobile view',
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/welcome-tour/slide-7-mobile.png'
      },
      content: {
        title: 'SKYMILES TRACKING RESOURCES',
        subtitle:
          'A reference key is located at the bottom of the tracker. It highlights the visual indicators for Earned Miles, Pending Miles and Completed Category.'
      }
    }
  ],
  analyticsEvent: {
    name: 'sm-modal-ready',
    value: 'Skymiles Tour Modal'
  },
  ariaLabels: {
    closeTour: 'close welcome tour',
    action: {
      next: 'next welcome tour slide',
      previous: 'previous welcome tour slide'
    }
  }
};
